<template>
  <div>
    <card-toolbar icon="settings" :title="$tc('system_information', 2)">
      <template #actions>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon id="pdfBtn" outline @click="pdf">
                save
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc("export_file") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon outline @click="refresh">
                autorenew
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc("refresh_information") }}</span>
        </v-tooltip>
      </template>
    </card-toolbar>

    <v-tabs
      show-arrows
      :ripple="false"
      v-model="selectedTab"
      slider-color="dinamo"
      background-color="transparent"
      centered
      class="mb-2"
    >
      <!-- Tabs -->
      <template>
        <v-tab v-for="(tab, key) in tabs" :id="`tab-${tab}`" ripple :key="`tab-${key}`">
          {{ $tc(tab) }}
        </v-tab>
      </template>
    </v-tabs>
    <v-card flat class="rounded-lg pa-0" outlined style="background: transparent;">
      <div class="pa-6">
        <v-tabs-items v-model="selectedTab">
          <v-tab-item>
            <tab-hardware />
          </v-tab-item>

          <v-tab-item>
            <tab-status />
          </v-tab-item>

          <v-tab-item>
            <tab-network />
          </v-tab-item>

          <v-tab-item>
            <tab-replication />
          </v-tab-item>

          <v-tab-item>
            <tab-password-policy />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf'
import HelperMixin from '@/mixins/helper'
import CardToolbar from '@/components/CardToolbar'
import TabHardware from './tabs/TabHardware'
import TabNetwork from './tabs/TabNetwork'
import TabPasswordPolicy from './tabs/TabPasswordPolicy'
import TabReplication from './tabs/TabReplication'
import TabStatus from './tabs/TabStatus'

export default {
  mixins: [HelperMixin],
  components: {
    TabHardware,
    TabNetwork,
    TabPasswordPolicy,
    TabReplication,
    TabStatus,
    CardToolbar
  },
  created () {
    this.refresh()
    this.setTab()
  },
  data () {
    return {
      selectedTab: null
    }
  },
  computed: {
    tabs () {
      return [
        'hardware',
        'status',
        'network',
        'replication',
        'password_policy'
        // 'usage_stats'
      ]
    },
    consoleVersion () {
      return this.$store.state.ui.version
    },
    logSize () {
      return this.$store.state.hsm.logSize
    }
  },
  methods: {
    refresh: async function () {
      await this.$store.dispatch('hsm/getInfo')
      await this.$store.dispatch('hsm/getLogSize')
    },
    getInterface (name, interfaces) {
      const information = interfaces.filter(item => item.name === name)
      let ans = ''

      if (information && information.length > 0) {
        const netmask2CIDR = information[0].mask
          .split('.')
          .map(Number)
          .map(part => (part >>> 0).toString(2))
          .join('')
        if (this.isBondActive(interfaces)) {
          ans = 'Slave'
        } else { ans = `${information[0].ip}/${netmask2CIDR.split('1').length - 1}` }
        ans += ` - ${information[0].up ? information[0].speed : 0} Mb/s - ${information[0].mac} - `
        if (information[0].up) {
          ans += '<span class="green--text">Link UP</span>'
        } else {
          ans += '<span class="red--text">Link DOWN</span>'
        }
      }
      return ans
    },
    getBound: function (interfaces) {
      const information = interfaces.filter(item => item.name === 'bond')

      this.isBondActive(information)

      let ans = this.$t('not_defined')

      if (information && information.length > 0 && information[0].ip !== '0.0.0.0' && information[0].ip !== '255.255.255.255') {
        let mode = ''

        switch (information[0].dgw) {
          case 1:
            mode = 'hot standy'
            break
          case 2:
            mode = 'balance'
            break
          case 3:
            mode = 'aggregation'
            break
          default:
            mode = this.$t('not_defined')
            break
        }

        const netmask2CIDR = information[0].mask
          .split('.')
          .map(Number)
          .map(part => (part >>> 0).toString(2))
          .join('')
        ans = `${information[0].ip}/${netmask2CIDR.split('1').length - 1} - ${mode}`
      }
      return ans
    },
    isBondActive: function (interfaces) {
      const information = interfaces.filter(item => item.name === 'bond')
      return information[0].ip !== '0.0.0.0' && information[0].ip !== '255.255.255.255'
    },
    bind_interface: function (nic, interfaces) {
      let ans = ''

      if (interfaces && interfaces.length > 0) {
        if (nic === 0) {
          const nic1 = interfaces.filter(item => item.name === 'nic1')
          const nic2 = interfaces.filter(item => item.name === 'nic2')
          if (nic1 && nic1.length > 0) ans += `<div>[1] - ${nic1[0].ip}</div>`
          if (nic2 && nic2.length > 0) ans += `<div>[2] - ${nic2[0].ip}</div>`
        } else {
          ans = `<div>[${nic}] - ${
            interfaces.filter(item => item.name === 'nic' + nic)[0].ip
          }</div>`
        }
      }
      return ans
    },
    getDefaultGateway: function (interfaces) {
      const information = interfaces.filter(
        item => item.name === 'default gateway'
      )
      let ans = ''
      if (information && information.length > 0) {
        ans = `${information[0].ip}`
      }
      return ans
    },
    pdf: function () {
      const file = 'hsm-info.pdf'

      // eslint-disable-next-line
      var doc = new jsPDF()

      const secPolicy = this.$store.state.secPolicy
      const info = this.$store.getters['hsm/GET_INFO']
      const report = `
      <div style="font-family: 'Courier', monospace;">
        <!-- <img src="${require('@/assets/images/Dinamo50x182.png')}" alt="some text" width=40px height=10px> -->
        <h2 style="font-size: 7px;text-align: center; margin-bottom: 8px;">HSM Information</h2>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('client')}</h4>
        <table style="font-size: 4px; margin-left: 32px;">
          <tr>
            <td style="text-align: right;">${this.$tc('webcon_version')}</td>
            <td>:</td>
            <td>${this.consoleVersion}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('operacional_system')}</td>
            <td>:</td>
            <td>${this.getOSStats()}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('browser')}</td>
            <td>:</td>
            <td>${this.getBrowserStats()}</td>
          </tr>
        </table>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('hardware')}</h4>
        <table style="font-size: 4px; margin-left: 46px;">
          <tr>
            <td style="text-align: right;">${this.$tc('manufacturer')}</td>
            <td>:</td>
            <td>${info.manufacturerID}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('model')}</td>
            <td>:</td>
            <td>${info.model}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('profile')}</td>
            <td>:</td>
            <td>${info.hardwareVersion}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('firmware_version')}</td>
            <td>:</td>
            <td>${info.firmwareVersion}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${info.tpoem ? this.$tc('tp_oem') : this.$tc('tp_key')}</td>
            <td>:</td>
            <td>${info.tpoem ? info.tpoem : info.tpkey}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('serial')}</td>
            <td>:</td>
            <td>${info.serialNumber}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('alias')}</td>
            <td>:</td>
            <td>${info.hsm_alias}</td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('loaded_module')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>${info.mods.map(mod => `<div>${mod}</div>`).join('')}</td>
          </tr>
        </table>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('status')}</h3>
        <table style="font-size: 4px; margin-left: -1px;">
          <tr>
            <td style="text-align: right;">${this.$tc('now')}</td>
            <td>:</td>
            <td>${this.$getDateString({ date: info.current_dt_info })}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('uptime')}</td>
            <td>:</td>
            <td>${this.getElapsedTimeString({ secondsInterval: (info.uptime) })}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('battery')}</td>
            <td>:</td>
            <td>${info.battery_ok === 1 ? this.$t('ok') : this.$t('low')}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('operation_mode')}</td>
            <td>:</td>
            <td>${this.hsm_mode()}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('storage')}</td>
            <td>:</td>
            <td>${Math.floor((1 - info.free_blocks / info.total_blocks) * 100) + '%'}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('log_size')}</td>
            <td>:</td>
            <td>${this.logSize} bytes (${this.$options.filters.prettyBytes(this.logSize)})</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('log_status')}</td>
            <td>:</td>
            <td>${info.state === 11 ? this.$t('enabled') : this.$t('disabled')}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('db_size')}</td>
            <td>:</td>
            <td>${this.$options.filters.prettyBytes(info.sl_be_len)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('total_users')}</td>
            <td>:</td>
            <td>${info.usr_count}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('total_objects')}</td>
            <td>:</td>
            <td>${info.obj_count}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('session', info.session)}</td>
            <td>:</td>
            <td>${info.session}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('cpu')}</td>
            <td>:</td>
            <td>${info.cpu + '%'}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('memory')}</td>
            <td>:</td>
            <td>${info.mem_used + '%'}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('pending_backup')}</td>
            <td>:</td>
            <td>${info.pending_backup}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('remoot')}</td>
            <td>:</td>
            <td>${info.remoot ? this.$t('yes') : this.$t('no')}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('pending_upack')}</td>
            <td>:</td>
            <td>${info.pending_upack}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('bind_dinamo_services')}</td>
            <td>:</td>
            <td>${info.ds_bound ? this.$t('yes') : this.$t('no')}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('ds_hsm')}</td>
            <td>:</td>
            <td>${info.ds_hsm}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('ds_account')}</td>
            <td>:</td>
            <td>${info.ds_account}</td>
          </tr>
          <tr>
        </table>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('network')}</h3>
        <table style="font-size: 4px; margin-left: 55px;">
          <tr>
            <td style="text-align: right;">${this.$t('interface', [1])}</td>
            <td>:</td>
            <td style="text-align: left;">${this.getInterface('nic1', info.interfaces)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$t('interface', [2])}</td>
            <td>:</td>
            <td style="text-align: left;">${this.getInterface('nic2', info.interfaces)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('gateway')}</td>
            <td>:</td>
            <td>${this.getDefaultGateway(info.interfaces)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('bond')}</td>
            <td>:</td>
            <td>${this.getBound(info.interfaces)}</td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('ntp')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>
            <div>${info.ntp_enabled ? this.$t('enabled') : this.$t('disabled')}</div>
            ${info.ntp_srv_info.map(el => `<div>${el.addr}</div>`).join('')}
            </td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('contact')}</td>
            <td>:</td>
            <td>${info.snmp.sys_contact}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('location')}</td>
            <td>:</td>
            <td>${info.snmp.sys_location}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('name')}</td>
            <td>:</td>
            <td>${info.snmp.community}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('trap')}</td>
            <td>:</td>
            <td>${info.routes === [] ? info.snmp.targets : this.$tc('none', 2)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('routes')}</td>
            <td>:</td>
            <td>${info.routes === [] ? info.routes.map(el => `<div>${el}</div>`).join('') : this.$tc('none', 2)}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('syslog')}</td>
            <td>:</td>
            <td>${info.syslog === [] ? info.syslog.map(el => `<div>${el}</div>`).join('') : this.$tc('none', 2)}</td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('filter')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>
            <div>${info.enabled ? this.$t('enabled') : this.$t('disabled')}</div>
            ${info.filter.filters.map(el => `<div>${el}</div>`).join('')}
            </td>
          </tr>
        </table>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('replication')}</h3>
        <table style="font-size: 4px; margin-left: 17px;">
          <tr>
            <td style="text-align: right;">${this.$tc('domain')}</td>
            <td>:</td>
            <td>${info.repl_domain}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('sync_point')}</td>
            <td>:</td>
            <td>${info.sync_point} ${info.SPVV}</td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('interface_bind')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>${this.bind_interface(info.bound_eth, info.interfaces)}</td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('policy')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>
            <div>${this.$tc('manager_pulsing')} - ${info.manager_pulse} secs</div>
            <div>${this.$tc('recovery_pulsing')} - ${info.recovery_pulse} secs</div>
            </td>
          </tr>
          <tr>
            <td style="text-align: right;vertical-align: top;">${this.$tc('node_list')}</td>
            <td style="text-align: center;vertical-align: top;">:</td>
            <td>${info.nodes.map(node => `<div>${node}</div>`).join('')}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('pending_transaction')} Peers</td>
            <td>:</td>
            <td>${info.peers}</td>
          </tr>
        </table>
        <h3 style="font-size: 6px;text-align: center;">${this.$tc('password_policy')}</h3>
        <table style="font-size: 4px; margin-left: 31px;">
          <tr>
            <td style="text-align: right;">${this.$tc('min_length')}</td>
            <td>:</td>
            <td>${secPolicy.min_len}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('special_char')}</td>
            <td>:</td>
            <td>${secPolicy.min_special}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('upcase_char')}</td>
            <td>:</td>
            <td>${secPolicy.min_upper}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('lowercase_char')}</td>
            <td>:</td>
            <td>${secPolicy.min_lower}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('invalid_logins')}</td>
            <td>:</td>
            <td>${secPolicy.max_inv_logins}</td>
          </tr>
          <tr>
            <td style="text-align: right;">${this.$tc('day_to_expire')}</td>
            <td>:</td>
            <td>${secPolicy.expiration}</td>
          </tr>
        </table>
      </div>
      `

      doc.html(report, {
        callback: function (doc) {
          doc.save(file)
          // window.open(doc.output('bloburl'))
        },
        autoPaging: 'text',
        windowWidth: 168,
        width: 168,
        margin: [10, 0, 10, 10]
      })
    },
    getBrowserStats () {
      const nAgt = navigator.userAgent
      let browserName = null
      let fullVersion = null
      let nameOffset, verOffset, ix

      if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browserName = 'Opera'
        fullVersion = nAgt.substring(verOffset + 6)
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          fullVersion = nAgt.substring(verOffset + 8)
        }
      } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browserName = 'Microsoft Internet Explorer'
        fullVersion = nAgt.substring(verOffset + 5)
      } else if ((verOffset = nAgt.indexOf('Edg/')) !== -1) {
        browserName = 'Microsoft Edge (Chromium)'
        fullVersion = nAgt.substring(verOffset + 5)
      } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browserName = 'Chrome'
        fullVersion = nAgt.substring(verOffset + 7)
      } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browserName = 'Safari'
        fullVersion = nAgt.substring(verOffset + 7)
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
          fullVersion = nAgt.substring(verOffset + 8)
        }
      } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browserName = 'Firefox'
        fullVersion = nAgt.substring(verOffset + 8)
      } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset)
        fullVersion = nAgt.substring(verOffset + 1)
      }
      if ((ix = fullVersion.indexOf(';')) !== -1) {
        fullVersion = fullVersion.substring(0, ix)
      }
      if ((ix = fullVersion.indexOf(' ')) !== -1) {
        fullVersion = fullVersion.substring(0, ix)
      }

      return `${browserName} - ${fullVersion}`
    },
    getOSStats () {
      let OSName = 'Unknown OS'
      if (navigator.userAgent.indexOf('Win') !== -1) OSName = 'Windows'
      if (navigator.userAgent.indexOf('Mac') !== -1) OSName = 'MacOS'
      if (navigator.userAgent.indexOf('X11') !== -1) OSName = 'UNIX'
      if (navigator.userAgent.indexOf('Linux') !== -1) OSName = 'Linux'
      if (navigator.userAgent.indexOf('Android') !== -1) OSName = 'Android'
      if (navigator.userAgent.indexOf('iPhone') !== -1) OSName = 'iOS'

      return OSName
    },
    setTab () {
      const query = this.$route.query

      if (query.tab) {
        switch (query.tab) {
          case 'hardware':
            this.selectedTab = 0
            break
          case 'status':
            this.selectedTab = 1
            break
          case 'network':
            this.selectedTab = 2
            break
          case 'replication':
            this.selectedTab = 3
            break
          case 'password_policy':
            this.selectedTab = 4
            break
          default:
            this.selectedTab = 0
            break
        }
      }
    },
    hsm_mode () {
      const mode = this.$store.state.hsm.statInfo.hsm_mode
      switch (mode) {
        case 0:
          return 'NRM'
        case 1:
          return 'RM1'
        case 2:
          return 'RM2'
        default:
          return 'unknown'
      }
    }
  },
  watch: {
    $route () {
      this.setTab()
    },
    selectedTab (val) {
      switch (val) {
        case 0:
          this.$router.push({ query: { tab: 'hardware' } })
          break
        case 1:
          this.$router.push({ query: { tab: 'status' } })
          break
        case 2:
          this.$router.push({ query: { tab: 'network' } })
          break
        case 3:
          this.$router.push({ query: { tab: 'replication' } })
          break
        case 4:
          this.$router.push({ query: { tab: 'password_policy' } })
          break
        default:
          this.$router.push({ query: { tab: 'hardware' } })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-tabs-items {
  background-color: transparent;
}
</style>
